import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=6dbd28c6&"
import script from "./CustomerModal.vue?vue&type=script&lang=js&"
export * from "./CustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbd28c6')) {
      api.createRecord('6dbd28c6', component.options)
    } else {
      api.reload('6dbd28c6', component.options)
    }
    module.hot.accept("./CustomerModal.vue?vue&type=template&id=6dbd28c6&", function () {
      api.rerender('6dbd28c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomerModal.vue"
export default component.exports